export const GET_IS_UNREAD = 'GET_IS_UNREAD'
export const GET_IS_UNREAD_PENDING = 'GET_IS_UNREAD_PENDING'
export const GET_IS_UNREAD_FULFILLED = 'GET_IS_UNREAD_FULFILLED'
export const GET_IS_UNREAD_REJECTED = 'GET_IS_UNREAD_REJECTED'

export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ'
export const MARK_ALL_AS_READ_PENDING = 'MARK_ALL_AS_READ_PENDING'
export const MARK_ALL_AS_READ_FULFILLED = 'MARK_ALL_AS_READ_FULFILLED'
export const MARK_ALL_AS_READ_REJECTED = 'MARK_ALL_AS_READ_REJECTED'
